import React, { Component } from "react";

import Header from "./Header";
import Body from "./Body";

import Navigation from "../common/Navigations";

class Dashboard extends Component {
  state = {
    currentSideNav: [],
  };

  syncNavigation = () => {
    const { pathname } = this.props.location;
    const sub = Navigation.getSub().filter(n => pathname === n.to || pathname.startsWith(n.to + '/')).sort((a,b) => b.to.length - a.to.length)[0];
    const currentSideNav = Navigation.getMain().find(n => n.id === sub?.parent || n.path.split('?')[0] === pathname);
    this.setState({ currentSideNav });
  };
  componentDidMount = () => this.syncNavigation();
  componentDidUpdate = previous => {
    if (previous.location.pathname !== this.props.location.pathname) this.syncNavigation();
  };

  //  Methods
  handleSideNavigation = (e) => {
    this.setState({ currentSideNav: e });
  };

  render() {
    const { currentSideNav } = this.state;

    return (
      <div className="main-body">
        <Header
          handleNav={this.handleTopNavigation}
          currentSideNav={currentSideNav}
          {...this.props}
        />
        <Body
          handleNav={this.handleSideNavigation}
          currentSideNav={currentSideNav}
        />
      </div>
    );
  }
}

export default Dashboard;
